
/**
 * Created by rathompson on 6/2/22
 * File: RemoveAppsModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useCallback, useEffect } from 'react'
import { Modal, ModalBody, ModalHeader, Button, ModalFooter, Body } from '@panwds/react-ui'
import {
  BUTTON_CANCEL, BUTTON_REMOVE, TITLE_REMOVE_APPS, LABEL_REMOVE_APPS
} from '../../constants/LabelConstants'

const RemoveAppsModal = ({ closeModal, isOpen, callback }) => {

  useEffect(() => {
    const modalMask = document.getElementsByClassName('tw-bg-gray-900 tw-fixed tw-inset-0 tw-z-10 tw-transition-opacity tw-duration-200 tw-opacity-75')
    if (modalMask && modalMask.length) {
      modalMask[0].style.zIndex = 1052
    }
  }, [isOpen])

  const onRemove = useCallback(() => {
    closeModal()
    callback()
  }, [callback, closeModal])

  return (
    <Modal style={{ zIndex: 1052, top: '50%', '--tw-translate-y': '-50%' }} size='sm' isOpen={isOpen} onClose={closeModal}>
      <ModalHeader title={TITLE_REMOVE_APPS}/>
      <ModalBody>
        <Body>{LABEL_REMOVE_APPS}</Body>
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal}>{BUTTON_CANCEL}</Button>
        <Button onClick={onRemove} appearance='secondary-destructive'>{BUTTON_REMOVE}</Button>
      </ModalFooter>
    </Modal>
  )
}

RemoveAppsModal.propTypes = {}
export default RemoveAppsModal
